module.exports = __webpack_public_path__ + "static/load-circles1-4db908316d681fb3b6914b1fd54cf826.png";